import { relativeServicedByInfo, JobHistory } from "@mysnowscape/snow-lib";

/**
 * relativeServicedByInfo walks a record's servicedBy chain looking for the
 * viewer's company, and throws if it never finds it. That is fine while the page
 * is pinned to the company you are switched into, but the property history can
 * now be scoped to several of your companies at once, and a record belonging to
 * one you are not currently in has a chain that never reaches your current
 * company. So resolve each record against whichever of your companies actually
 * appears in its chain.
 *
 * Walking up from the company that performed the work means we resolve against
 * your closest relationship to the record, which is what keeps the label showing
 * your direct partner rather than someone further down the chain.
 */
export default function servicedByLabel(
  job: JobHistory,
  viewerCompanyIds: Array<string | undefined>,
): string {
  const ids = new Set(
    viewerCompanyIds.filter(Boolean).map((id) => id!.toString()),
  );
  let node = job?.servicedBy ?? null;
  while (node != null) {
    if (node.id != null && ids.has(node.id.toString())) {
      return relativeServicedByInfo(job, node.id);
    }
    node = node.onBehalfOf ?? null;
  }
  // None of your companies is in the chain, which should not happen because the
  // backend only returns records one of them can see.
  return "";
}
